import api, { Pagination } from '..'

export class DispatchingService {
  static async findAll(pagination: Pagination) {
    const response = await api.get(
      `/dispatchings?state!=canceled&populate=creditLine,dispatchingFile&page=${pagination.page}&perPage=${pagination.perPage}`
    )
    return response.data
  }

  static async findAllForRefunds(pagination: Pagination) {
    const response = await api.get(
      `/dispatchings/refunds?page=${pagination.page}&perPage=${pagination.perPage}`
    )
    return response.data
  }
}
